import { zod } from '@acme/core'
import { z } from 'zod'

import dayjs from 'dayjs'
import ApiService from '../api.service'

export type CompensacaoFeriado = z.infer<typeof zod.CompensacaoFeriadoSchema>

export const createCompensacaoFeriadoSchema = zod.CompensacaoFeriadoSchema.omit(
    {
        id: true,
        createdAt: true,
        updatedAt: true,
        deletedAt: true,
        dataCompensacao: true,
        dataFeriado: true,
    },
)
    .extend({
        dataCompensacao: z.date().or(z.string().nonempty('Obrigatório')),
        dataFeriado: z.date().or(z.string().nonempty('Obrigatório')),
    })
    .refine(
        data =>
            !dayjs(data.dataCompensacao).isSame(dayjs(data.dataFeriado), 'day'),
        {
            message:
                'A data de compensação deve ser diferente da data do feriado',
            path: ['dataCompensacao'],
        },
    )

/**
 * @usage softDelete
 */
export const compensacaoFeriados = new ApiService<CompensacaoFeriado>(
    'compensacao-feriados',
)
